import { useState } from 'react';
import { LoginResponse } from '@app/utils/utils';

export default function useToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem('token');
    if (tokenString != null && tokenString !== 'undefined') {
      return tokenString;
    }
    return null;
  };

  const [token, setToken] = useState<string | null>(getToken());

  const saveToken = (userToken: LoginResponse) => {
    if (userToken && userToken.accessToken) {
      localStorage.setItem('token', userToken.accessToken);
      localStorage.setItem('tokenType', userToken.tokenType || 'Bearer');
      if (userToken.roles) {
        localStorage.setItem('roles', JSON.stringify(userToken.roles));
      }
      if (userToken.displayName) {
        localStorage.setItem('displayName', userToken.displayName);
      }
      setToken(userToken.accessToken);
    }
  };

  return {
    setToken: saveToken,
    token
  };
}
